import {IOrganization} from "../../../organizations/interfaces/IOrganization";
import {Grid, AlertTypes, FormChips, MainLoader} from "@leap4/frontend";
import React, {useContext, useEffect, useState} from "react";
import {IPublisherLogins} from "../../interfaces/IPublisherLogins";
import {ApiClient} from "../../../../utils/apiClient";
import {organizationPartnersUrl} from "../../../../config/generals";
import {setAlert} from "../../../../actions/alert";
import {PublisherLoginContext} from "../PublisherLoginContex";

export interface IPublisherLoginsProps {
    currentPublisherLogin: IPublisherLogins
}

export interface  IOrganizationPartners {
    org: IOrganization,
    optionalPartners: string[],
    selectedPartners: string[]

}

export const PartnerContainer = (props: IPublisherLoginsProps) => {
    const {publisherLogin, setPublisherLogin} = useContext(PublisherLoginContext);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [allPartners, setAllPartners] = useState<{id: string, name: string}[]>([]);

    const updatePartners = (items) => {
        setPublisherLogin({
            advertiserId: publisherLogin.advertiserId,
            publisherId: publisherLogin.publisherId,
            advertiserName: publisherLogin.advertiserName,
            publisherName: publisherLogin.publisherName,
            supplyPartners: items.map(item => allPartners.find(p => p.id === item))
        })
    }

    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                const allData =  (await ApiClient.get(organizationPartnersUrl, {params: {organization: props.currentPublisherLogin.publisherId.toString()}})).data;
                if (!allData || !allData?.length) {
                    return;
                }
                setAllPartners(allData);
            } catch (e) {
                setAlert(e.toString(), AlertTypes.FAILURE)
            } finally {
                setIsLoading(false);
            }
        })()
    }, [])

    if (isLoading) return <Grid item padding={0}>
        <MainLoader/>
    </Grid>;
    return (
        <>
            <Grid margin={"30px"}>
            </Grid>
            <Grid item width='100%' margin={"0px"}>
                <FormChips optionsList={allPartners}
                           onUpdateItems={updatePartners}
                           inputName={"Supply Partners"}
                           enableCreate={false}
                           chips={publisherLogin.supplyPartners.map(partner => partner.id.toString())}
                           pureCreate={false}
                           textFieldProps={{size: "small", style: {width: "100%"}}}
                           stackProps={{style: {width: "100%"}}}
                           labelKey={"name"}
                           valueKey={"id"}
                           disableCloseOnSelect={false}
                />
            </Grid>
        </>
    )
}



